

























import { Vue, Component, Prop} from 'vue-property-decorator'
@Component
export default class ContentBlock extends Vue {
	@Prop() private title!: string
	@Prop() private titleIcon!: string
	@Prop({
		type: Array,
		required: false,
		default: () => {
			return []
		}
	})
	private listData!: object
}
